import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { omit } from "lodash";
import NbfcLogin from "../../components/login/nbfcLogin";
import { nbfcLoginRequest } from "../../store/actions/nbfcLoginAction";
import Swal from "sweetalert2";

export default function NbfcLoginContainer(){

    const [fields, setFields] = useState({
        email:'',
        password:''
    });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginObj = useSelector(state => state.nbfcLoginReducer);
    const { loading, loginResult, error } = loginObj;

    let errorReturn = {};
    let errorObj = errors;
    //console.log("loginObj",loginObj)
    useEffect(() => {
         if(loginResult?.access){
             navigate('/create-auction');
         }
    },[loginResult])

    useEffect(() => {
        if(error?.response){
            Swal.fire({
				icon: "error",
				confirmButtonColor: "#652078",
				text: error?.response?.data?.message ? error?.response?.data?.message : "Something went wrong..."
			}).then((res) => {
				if (res) {
				}
			});
        }
   },[error?.response])

            

    // useEffect(() => {
    //   if (otpResult?.status && timer > 0) {
    //     const interval = setInterval(() => {
    //       setTimer(prevTimer => prevTimer - 1);
    //     }, 1000);
        
    //     return () => clearInterval(interval);
    //   }
    // }, [otpResult?.status]);

    const validate = (name, value) => {
        if(value === "" && name==="email"){
            errorObj =  {...errorObj, [name]: "Please enter email id."};
        }else if(value !== "" && name==="email" && (!((/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(value))) ){
            ///^[6-9][0-9]{10}/
            errorObj =  {...errorObj, [name]: "Please enter valid email id."};
        }else if(value === ""&& name==="password"){
            errorObj =  {...errorObj, [name]: "Please enter password."};
        }else if(errors?.hasOwnProperty(name)){
            let newObj = omit(errors, name);
            errorObj = newObj;
        }

        return errorObj;
    }

    const submitNbfcLoginRequest = (e) => {
        e.preventDefault();
        let defaultFieldJsonKey = Object.keys(fields); 
        for(let i = 0; i < defaultFieldJsonKey.length; i++){
          if(defaultFieldJsonKey){
              errorReturn = validate(defaultFieldJsonKey[i], fields[defaultFieldJsonKey[i]]);
          }
        }    
        if(Object.keys(errorReturn).length === 0){
            dispatch(nbfcLoginRequest({loginReq:fields}))            
        }else{
            setErrors(errorReturn);
        }
    }

    const handleChange = (e) => {
            const { name, value } = e.target;
            errorReturn = validate(name,value);
            setErrors(errorReturn);
            setFields(prev => ({
                ...prev,
                [name]: value
           }))
        }

    

    return (
			<NbfcLogin
				handleChange={handleChange}
				submitNbfcLoginRequest={submitNbfcLoginRequest}
				fields={fields}
				loading={loading}
				errors={errors}
			/>
		);
}